<template>
  <span>
    <v-menu bottom>
      <template v-slot:activator="{on}">
        <v-btn text
               color="white"
               v-on="on"
               outlined>
            {{formatDate()}}
            <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list color="kbWhite" dense>
        <v-list-item @click="changeSelection(1)">
            <v-list-item-title>
                Hoy
            </v-list-item-title>
        </v-list-item>

        <v-list-item @click="changeSelection(7)">
            <v-list-item-title>
                7 {{$tc('general.day', 2)}}
            </v-list-item-title>
        </v-list-item>

        <v-list-item @click="changeSelection(15)">
            <v-list-item-title>
                15 {{$tc('general.day', 2)}}
            </v-list-item-title>
        </v-list-item>

        <v-list-item @click="changeSelection(30)">
            <v-list-item-title>
                1 {{$tc('general.month', 1)}}
            </v-list-item-title>
        </v-list-item>

        <v-list-item @click="changeSelection(60)">
            <v-list-item-title>
                2 {{$tc('general.month', 2)}}
            </v-list-item-title>
        </v-list-item>

        <v-list-item @click="changeSelection(90)">
            <v-list-item-title>
                3 {{$tc('general.month', 2)}}
            </v-list-item-title>
        </v-list-item>

        <v-list-item @click="changeSelection(180)">
            <v-list-item-title>
                6 {{$tc('general.month', 2)}}
            </v-list-item-title>
        </v-list-item>

        <v-list-item @click="changeSelection(365)">
            <v-list-item-title>
                1 {{$tc('general.year', 1)}}
            </v-list-item-title>
        </v-list-item>

        <v-list-item @click="changeSelection('custom')">
          <v-list-item-title>
            Personalizado
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu v-model="menuDatePicker"
            :close-on-content-click="false"
            :close-on-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px">
    <template v-slot:activator="{ on }">
      <v-btn text
             v-show="selection === 'custom'"
             v-on="on">
        {{value.join(' - ')}}
      </v-btn>
    </template>

    <v-date-picker :color="color || 'primary'"
                   range
                   v-model="dates">
      <v-spacer/>

      <v-btn @click="closeMenu()"
             :color="color || 'primary'"
             text>
        Aceptar
      </v-btn>
    </v-date-picker>
  </v-menu>
  </span>
</template>

<script>
export default {
  created () {
    this.dates = [`${this.$moment().format('YYYY-MM-DD')}`]
    this.$emit('input', this.dates)
  },
  data: () => ({
    dates: [],
    menuDatePicker: false,
    selection: 1
  }),
  methods: {
    changeSelection (value) {
      this.selection = value

      if (value === 'custom') {
        this.$nextTick().then(() => {
          this.menuDatePicker = true
        })
        return
      }

      this.dates = [
        `${this.$moment().subtract(value - 1, 'days').format('YYYY-MM-DD')}`,
        `${this.$moment().format('YYYY-MM-DD')}`
      ]

      this.$emit('input', this.dates)
    },
    closeMenu () {
      this.dates = this.dates.sort()
      this.$emit('input', this.dates)
      this.menuDatePicker = false
    },
    formatDate () {
      switch (this.selection) {
        case 1:
          return 'Today'
        case 7:
          return `7 ${this.$tc('general.day', 2)}`
        case 15:
          return `15 ${this.$tc('general.day', 2)}`
        case 30:
          return `1 ${this.$tc('general.month', 1)}`
        case 60:
          return `2 ${this.$tc('general.month', 2)}`
        case 90:
          return `3 ${this.$tc('general.month', 2)}`
        case 180:
          return `6 ${this.$tc('general.month', 2)}`
        case 365:
          return `1 ${this.$tc('general.year', 1)}`
        default:
          return 'Personalizado'
      }
    }
  },
  props: ['color', 'value']
}
</script>
